import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/scss/styles.scss";
import Header from "./components/Header/Header";
import Intro from "./components/Intro/Intro";
import Aliado from "./components/Aliado/Aliado";
import Objetivo from "./components/Objetivo/Objetivo";
import Presencia from "./components/Presencia/Presencia";
import Socios from "./components/Socios/Socios";
import Clientes from "./components/Clientes/Clientes";
import Contacto from "./components/Contacto/Contacto";
import Trabajo from "./components/Trabajo/Trabajo";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Header />
          <Intro />
          <Aliado />
          <Objetivo />
          <Presencia />
          <Socios />
          <Clientes />
          <Contacto />
          <Trabajo />
          <Footer />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;

